module.exports = __webpack_public_path__ + "static/media/7.36cad7be.png";